define('app/models/BenchmarkCollection',['require','glu/collection','config'],function(require) {
	'use strict';

	var Collection = require('glu/collection'),
		config = require('config');

	return Collection.extend({
		url: config.apiRoot + 'service/benchmarks',

		parse: function(res) {
			return res.data;
		}
	});

});

